var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Alert } from '@payscale/design';
var FileAlert = (function (_super) {
    __extends(FileAlert, _super);
    function FileAlert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FileAlert.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (React.createElement(Alert, { className: "pxl-margin-bottom-md", level: "danger", message: this.renderFileErrorMessages(), onClickClose: this.props.onClose, close: true }));
        }
    });
    Object.defineProperty(FileAlert.prototype, "renderFileErrorMessages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (React.createElement("span", null,
                React.createElement("b", null, this.props.error.errorTitle),
                React.createElement("br", null),
                this.props.error.errorMessages.map(function (error, index) { return (React.createElement("span", { key: index },
                    error,
                    React.createElement("br", null))); })));
        }
    });
    return FileAlert;
}(React.Component));
export { FileAlert };
